import { atom } from "recoil";

const choosedLogoAtom = atom({
  key: "choosedLogoState",
  default: JSON.parse(localStorage.getItem("logoChoice")) ?? {},
});

export default choosedLogoAtom;
